import { ChevronLeft } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Heading, Input, Text, XStack, YStack } from 'tamagui';
import { tokens } from 'tamagui-config';

import { DividerLine } from '../../../components/common/DividerLine';
import { GradientButton } from '../../../components/common/GradientButton';

interface WifiPasswordPromptProps {
  input: string;
  onInputChange: (val: string) => void;
  onShowKeyboard: () => void;
  networkName?: string;
  goBack: () => void;
}

export const WifiPasswordPrompt: React.FC<WifiPasswordPromptProps> = ({
  input,
  onInputChange,
  onShowKeyboard,
  networkName,
  goBack,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <XStack alignItems="center" gap="$3.5">
        <Button
          icon={<ChevronLeft size={24} strokeWidth={4} color={tokens.color.white12} />}
          circular
          minWidth={72}
          minHeight={72}
          borderWidth="$1"
          borderColor="$transparentBorder"
          onPress={goBack}
          backgroundColor="$transparentBorder"
        />
        <Heading color="$textLight" fontSize="$6" fontWeight="$5">
          {networkName ? decodeURIComponent(networkName) : t('settings.wifi.unknownNetwork')}
        </Heading>
      </XStack>
      <Text fontSize="$8.5" color="$white12">
        {t('settings.wifi.typePassword')}
      </Text>
      <DividerLine />
      <YStack height={203} justifyContent="center" alignItems="flex-start" gap="$5">
        <Input
          height={72}
          paddingVertical={16}
          paddingHorizontal={24}
          alignItems="center"
          alignSelf="stretch"
          borderRadius={7}
          borderWidth={1}
          backgroundColor="$formInputBackground"
          borderColor="$gray8"
          fontSize="$8.5"
          placeholder={t('settings.wifi.wifiPassword')}
          value={input}
          onChangeText={onInputChange}
          secureTextEntry
          focusStyle={{
            borderColor: '$gray8',
            borderWidth: 1,
            outlineWidth: 0,
            outlineStyle: 'none',
          }}
          focusVisibleStyle={{
            outlineWidth: 0,
            outlineStyle: 'none',
          }}
          onFocus={onShowKeyboard}
        />
        <GradientButton
          label={t('settings.wifi.connect')}
          isActive={true}
          onPress={onShowKeyboard}
          width="168px"
        />
      </YStack>
    </>
  );
};
